var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('ResponsiveIcon',{attrs:{"image-url":_vm.image.url,"width":_vm.image.width,"height":_vm.image.height,"alt-text":_vm.altText || _vm.image.name}}):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }